import React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import i18n from 'src/i18n';

import signInViewModel from '../Header/component/SignIn/viewModel';
import withProfile from '../withProfile';
import AlertView from '../Alert';

import styles from './styles.module.scss';

@observer
class PurchaseAlert extends React.Component {
  render() {
    const { viewModel, profile } = this.props;

    return (
      <AlertView
        vm={viewModel}
        className={styles.zIndex}
        showClose={false}
        showButtons={false}
        contentContainerStyles={styles.modalContentContainer}
      >
        <div className={styles.modalContent}>
          <div className={styles.modalHeader}>
            {i18n.t('modal_alert')}
          </div>
          <div className={styles.headerContainer}>
            {viewModel.isPurchaseOnly ? i18n.t('course_purchase_to_purchase') : i18n.t('course_purchase_to_go_subscribe')}
          </div>
          <div className={styles.btnContainer}>
            <div
              className={styles.cancelBtn}
              onClick={viewModel.handlerCloseAlert}
            >
              {i18n.t('btn_cancel')}
            </div>
            {
              viewModel.isPurchaseOnly
                ? (
                  <>
                    {
                      profile
                        ? (
                          <Link
                            to={`/purchase/${viewModel.courseId}`}
                            className={styles.purchaseBtn}
                            onClick={viewModel.handlerCloseAlert}
                          >
                            {i18n.t('course_purchase_go_purcahse')}
                          </Link>
                        )
                        : (
                          <div
                            className={styles.purchaseBtn}
                            onClick={signInViewModel.handleOpen}
                          >
                            {i18n.t('course_purchase_go_purcahse')}
                          </div>
                        )
                    }
                  </>
                )
                : (
                  <Link
                    to="/subscription"
                    className={styles.purchaseBtn}
                    onClick={viewModel.handlerCloseAlert}
                  >
                    {i18n.t('course_purchase_go_subscribe')}
                  </Link>
                )
            }
          </div>
        </div>
      </AlertView>
    );
  }
}

PurchaseAlert.propTypes = {
  viewModel: PropTypes.object,
  profile: PropTypes.object
};

PurchaseAlert.defaultProps = {
  viewModel: {},
  profile: {}
};

export default withProfile(PurchaseAlert, false);
